import { useRef, useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { focusNext } from "@/lib/formKeys";

export function ComboBox({ options, value, onChange, placeholder = "Pilih...", searchPlaceholder = "Cari...", emptyText = "Tidak ditemukan", testid }) {
  const [open, setOpen] = useState(false);
  const trig = useRef(null);
  const selected = options.find((o) => o.value === value);
  const pick = (v) => {
    onChange(v === value ? "" : v);
    setOpen(false);
    setTimeout(() => { if (trig.current?.closest("[role=dialog]")) focusNext(trig.current); }, 50);
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button ref={trig} variant="outline" role="combobox" className="w-full justify-between font-normal" data-testid={testid}>
          <span className={cn("truncate", !selected && "text-muted-foreground")}>{selected ? selected.label : placeholder}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command filter={(v, s) => (options.find((o) => o.value === v)?.label || v).toLowerCase().includes(s.toLowerCase()) ? 1 : 0}>
          <CommandInput placeholder={searchPlaceholder} data-testid={testid ? `${testid}-search` : undefined} />
          <CommandList>
            <CommandEmpty>{emptyText}</CommandEmpty>
            <CommandGroup>
              {options.map((o) => (
                <CommandItem key={o.value} value={o.value} onSelect={pick}>
                  <Check className={cn("mr-2 h-4 w-4", value === o.value ? "opacity-100" : "opacity-0")} />
                  {o.label}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
